import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function LoginPage() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate('/dashboard', { replace: true });
  }, [loading, user, navigate]);

  return (
    <div style={wrap}>
      <div style={card}>
        <span style={mark} aria-hidden="true">SJ</span>
        <p style={eyebrow}>SJ Hub</p>
        <h1 style={title}>Sign in</h1>
        <p style={lead}>
          Use your work Microsoft account to access invoice uploads and approvals.
        </p>
        <button onClick={login} disabled={loading} style={btn}>
          {loading ? 'Loading...' : 'Sign in with Microsoft'}
        </button>
      </div>
    </div>
  );
}

const wrap: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  paddingTop: 48,
  paddingBottom: 48
};

const card: React.CSSProperties = {
  width: '100%',
  maxWidth: 440,
  background: 'var(--sj-paper)',
  border: '1px solid var(--sj-line)',
  borderRadius: 'var(--radius)',
  boxShadow: 'var(--shadow-card)',
  padding: '40px 36px 36px',
  textAlign: 'center'
};

const mark: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 56,
  height: 56,
  background: 'var(--sj-crimson)',
  color: '#fff',
  fontFamily: 'var(--font-display)',
  fontSize: '2rem',
  letterSpacing: 1,
  borderRadius: 6,
  boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
  marginBottom: 18
};

const eyebrow: React.CSSProperties = {
  fontFamily: 'var(--font-body)',
  fontWeight: 700,
  fontSize: 12,
  letterSpacing: '0.22em',
  textTransform: 'uppercase',
  color: 'var(--sj-crimson)',
  margin: '0 0 4px'
};

const title: React.CSSProperties = {
  fontFamily: 'var(--font-display)',
  fontSize: '2.4rem',
  letterSpacing: 1,
  textTransform: 'uppercase',
  margin: '0 0 12px',
  color: 'var(--sj-text-dark)'
};

const lead: React.CSSProperties = {
  color: 'var(--sj-text-muted)',
  margin: '0 0 28px',
  lineHeight: 1.5
};

const btn: React.CSSProperties = {
  padding: '14px 28px',
  fontSize: 15,
  fontWeight: 700,
  letterSpacing: '0.04em',
  background: 'var(--sj-crimson)',
  color: '#fff',
  border: 'none',
  borderRadius: 999,
  cursor: 'pointer',
  width: '100%',
  textTransform: 'uppercase'
};
